import { Fragment } from "react";
import Menu from "../../modules/public/menu/menu";
import Footer from "../../modules/public/footer/footer";
import usePage from "../../hooks/usePage";
import { Col, Container } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { developersList } from "./DevelopersPage";
import style from "./DevelopersPage.module.css";
import WebServiceForm from "../webService/WebServiceForm";

const DevelopersItemPage = () => {
  const { pathname } = useLocation();
  const boxItem = developersList.find(item => item.url === pathname);

  const { pageSliders, pageImage, pageText } = usePage();

  if (!boxItem) {
    return null;
  }

  const actionLabel = boxItem.actionLabel || "دانلود";
  const actionUrl = boxItem.downloadUrl;

  return (
    <Fragment>
      <Menu />

      <main className="flex-grow-1">
        {pageSliders}

        <Container className="rtl-all my-6">
          <nav>
            <ul className="list-inline d-flex p-0 column-gap-2">
              <li>
                <Link to="/developers">توسعه دهندگان</Link>
              </li>
              <li> / </li>
              <li>
                <Link to={pathname}>{boxItem.title}</Link>
              </li>
            </ul>
          </nav>

          {!boxItem.hideSideCard && (
            <div className=" col-12 col-sm-6 col-md-4 float-start mt-4 me-5 pb-2">
              <div className="light-shadow px-3 py-3 my-2 bg-body rounded card">
                <img
                  src={boxItem.image}
                  className={`w-100 rounded ${style.img}`}
                  alt={boxItem.title}
                />

                <div className="d-flex flex-wrap mt-2">
                  <div className="w-100 w-md-75 pb-2">{boxItem.title}</div>
                  {actionUrl && (
                    <Link
                      className="btn-success-style text-center rounded mt-4"
                      to={actionUrl}
                      target={actionUrl.startsWith("http") ? "_blank" : undefined}
                    >
                      {actionLabel}
                    </Link>
                  )}
                </div>
              </div>
            </div>
          )}

          {pageText}

          {boxItem.videoUrl && (
            <Col xs={12} lg={8} className="mt-7 px-5 mx-auto">
              <h4 className="mb-3 text-center">فیلم آموزشی اتصال و استفاده از پنل</h4>
              <video
                autoPlay
                width="100%"
                height="100%"
                src={boxItem.videoUrl}
                controls
              />
            </Col>
          )}

          {pageImage}
        </Container>

        {!boxItem.hideWebServiceForm && <WebServiceForm />}
      </main>

      <Footer />
    </Fragment>
  );
};

export default DevelopersItemPage;
